<template>
	<div class="distributor-address-list">
		<div class="common-header-wrap">
			<mt-header title="收货地址" class="common-header">
				<mt-button slot="left" icon="back" @click="goBack"></mt-button>
			</mt-header>
		</div>

		<div class="pb-30" v-if="address_list.length>0">
			<div class="item" v-for="item in address_list" :key="item.address_id">
				<div class="container">
					<div class="top-wrapper">
						<div class="selected-wrapper">
							<div class="line">
								<i class="icon iconfont">&#xe6d3;</i>
								<div class="line-content">
									<div class="title-wrapper">
										<label class="title">{{item.address_realname}}</label>
										<label class="title" style="margin-left:1rem;">{{item.address_mob_phone}}</label>
									</div>
									<div class="desc address-text">{{item.area_info}}{{item.address_detail}}</div>
								</div>
							</div>
						</div>
						<div class="bottom-line"></div>
					</div>

					<div class="bottom-wrapper">
						<div class="bottom-left-wrapper" @click="onDefault(item)">
							<label class="subtitle">
								<i v-if="item.address_is_default == 1" class="iconfont">&#xe69d;</i><i v-else class="iconfont">&#xe69e;</i>默认地址
							</label>
						</div>
						<div class="bottom-right-wrapper">
							<div class="edit-wrapper" @click="onEdit(item)">
								<div class="common-btn btn-2 mr-5">编辑</div>
							</div>
							<div class="edit-wrapper delete-wrapper" @click="onDelete(item.address_id)">
								<div class="common-btn btn-1">删除</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div  v-else>
			<empty-record></empty-record>
		</div>
		<div class='common-add-btn-wrapper'><div class="div common-btn common-add-btn"  @click="goAdd">新增</div></div>
	</div>
</template>

<script>

import { Toast, Indicator, MessageBox } from 'mint-ui'
import EmptyRecord from '../../EmptyRecord'
import { getAddressList, delAddress, editAddress } from '../../../api/memberAddress'
export default {
  components: {
    EmptyRecord
  },
  name: 'MemberAddressList',
  data () {
    return {
      address_list: []
    }
  },
  created: function () {
    this.getAddressList()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    goAdd () {
      this.$router.push({ name: 'MemberAddressForm', query: { action: 'add' } })
    },
    onDefault (address_info) {
      address_info.address_is_default = 1
      editAddress(address_info, address_info.address_id).then(
        (response) => {
          Indicator.close()
          this.getAddressList()
        }, (error) => {
          Indicator.close()
          Toast(error.message)
        })
    },
    onEdit (address) {
      if (!address.chain_id) {
        this.$router.push({ name: 'MemberAddressForm', query: { address_id: address.address_id } })
      } else {
        this.$router.push({ name: 'MemberChainForm', query: { address_id: address.address_id, action: 'edit' } })
      }
    },
    onDelete (addressId) {
      MessageBox.confirm('确定要删除该地址吗？').then(action => {
        Indicator.open()
        delAddress(addressId).then(
          (response) => {
            this.getAddressList()
            Indicator.close()
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      })
    },
    getAddressList () {
      getAddressList().then(res => {
        this.address_list = res.result.address_list
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
	.distributor-address-list {
		.common-header{
			.btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
		}
		.line{display: flex;
			.line-content{flex:1}
		}
		.item{margin-bottom:$modelSpace}
		.container{background: #fff;padding:0 $pageSpace}
		.btn-1{border:1px solid $primaryColor;color:$primaryColor;min-width: 2rem}
		.btn-2{border:1px solid #333;color:#333;min-width: 2rem}
		.top-wrapper {
			position: relative;
			flex: 1;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;
			background-color: #fff;
		}
		.title-wrapper {
			height: 1rem;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;
		}
		.icon {
			font-size:$h1;
			margin-right: .2rem;
			color:$primaryColor
		}
		.title {
			font-size:$h3;
			color: #333;
			font-weight: 700;
		}
		.default {
			width: 1.4rem;
			margin-left: 0.5rem;
			margin-right: 0.5rem;
			border: 1px solid $primaryColor;
			color: $primaryColor;
			font-size:$h6;
			text-align: center;
			border-radius: 0.1rem;
		}
		.desc {
			color: $descTextColor;
			font-size:$subFontSize;
		}
		.address-text {
			margin-top: .3rem;
			font-weight: normal;
		}
		.selected-wrapper{
			padding:1rem 0;
		}
		.bottom-line {
			position: absolute;
			left: 0;
			bottom: 0;
			right: 0;
			border-bottom:1px dashed #eee
		}
		.bottom-wrapper {
			height: 2.5rem;
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			align-items: stretch;
			align-items: center;
		}
		.bottom-left-wrapper {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;
		}
		.bottom-right-wrapper {
			flex: 1;
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			align-items: stretch;
		}
		.edit-wrapper {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;
		}
		.delete-wrapper {
			margin-right: 0.5rem;
		}
		.subtitle {
			font-size:$subFontSize;
			color: $descTextColor;
		}
		.subtitle i{font-size:$h2;margin-right:.5rem;}
	}

</style>
